/**
 * allInsightsArticles — the single canonical merge of every code-defined
 * article rendered on /insights. Previously this list lived (duplicated) in
 * InsightsPage.jsx and ArticlePage.jsx; it is now centralised here so the
 * public pages AND the Content Hub importer all see the exact same corpus.
 */
import { articles as originalArticles } from '@/data/articlesData';
import { sellerArticles } from '@/data/sellerArticlesData';
import { residentialSellerArticles } from '@/data/residentialSellerArticlesData';
import { landownerArticles } from '@/data/landownerArticlesData';
import { developmentInsightsArticles } from '@/data/developmentInsightsArticlesData';
import { sellerSegmentArticles } from '@/data/sellerSegmentArticlesData';
import { allSuburbArticles } from '@/data/suburbs';
import { sellToDeveloperArticles } from '@/data/sellToDeveloperArticles';
import { valuationLeadGenArticles } from '@/data/valuationLeadGenArticles';
import { allPlanningArticles } from '@/data/councilPlanningArticles';
import { olympicsImpactArticles } from '@/data/olympicsImpactArticles';
import { stationArticles } from '@/data/stationArticles';
import { quarterlyMarketReports, zoningAlertArticles } from '@/data/councilMarketArticles';
import { topListArticles } from '@/data/topListArticles';
import { comparisonArticles } from '@/data/comparisonArticles';
import { zoningExplainerArticles, canIBuildArticles, planningMistakeArticles, overlayExplainerArticles } from '@/data/townPlanningArticles';
import { aeoPillarArticles } from '@/data/aeoPillarArticles';
import { aeoThoughtLeadershipArticles } from '@/data/aeoThoughtLeadershipArticles';
import { aeoQuickAnswerArticles } from '@/data/aeoQuickAnswerArticles';
import { aeoDeveloperStrategyArticles } from '@/data/aeoDeveloperStrategyArticles';
import { aeoDeveloperStrategyBatch2 } from '@/data/aeoDeveloperStrategyBatch2';
import { aeoSellerEducationBatch } from '@/data/aeoSellerEducationBatch';
import { aeoCommercialInstitutionalBatch } from '@/data/aeoCommercialInstitutionalBatch';
import { aeoCommercialInstitutionalBatch2 } from '@/data/aeoCommercialInstitutionalBatch2';
import { aeoTransactionStructuresBatch } from '@/data/aeoTransactionStructuresBatch';
import { aeoAiFutureBatch } from '@/data/aeoAiFutureBatch';
import { aeoPillarSellerGapsBatch } from '@/data/aeoPillarSellerGapsBatch';
import { aeoSuburbDeepDivesBatch } from '@/data/aeoSuburbDeepDivesBatch';
import { aeoQuarterlyReportsBatch } from '@/data/aeoQuarterlyReportsBatch';
import { aeoSellerEducationClosoutBatch } from '@/data/aeoSellerEducationClosoutBatch';

export const allInsightsArticles = [
  ...originalArticles,
  ...sellerArticles,
  ...residentialSellerArticles,
  ...landownerArticles,
  ...developmentInsightsArticles,
  ...sellerSegmentArticles,
  ...allSuburbArticles,
  ...sellToDeveloperArticles,
  ...valuationLeadGenArticles,
  ...allPlanningArticles,
  ...olympicsImpactArticles,
  ...stationArticles,
  ...quarterlyMarketReports,
  ...zoningAlertArticles,
  ...topListArticles,
  ...comparisonArticles,
  ...zoningExplainerArticles,
  ...canIBuildArticles,
  ...planningMistakeArticles,
  ...overlayExplainerArticles,
  ...aeoPillarArticles,
  ...aeoThoughtLeadershipArticles,
  ...aeoQuickAnswerArticles,
  ...aeoDeveloperStrategyArticles,
  ...aeoDeveloperStrategyBatch2,
  ...aeoSellerEducationBatch,
  ...aeoCommercialInstitutionalBatch,
  ...aeoCommercialInstitutionalBatch2,
  ...aeoTransactionStructuresBatch,
  ...aeoAiFutureBatch,
  ...aeoPillarSellerGapsBatch,
  ...aeoSuburbDeepDivesBatch,
  ...aeoQuarterlyReportsBatch,
  ...aeoSellerEducationClosoutBatch,
];

export default allInsightsArticles;
